import Vue from 'vue';
import Vuex from 'vuex';
import { LocationStatus } from '@/enums';

import state, { RootState } from './state';
import mutations from './mutations';
import actions from './actions';

import user from './modules/user';
import cart from './modules/cart';
import merchant from './modules/merchant';
import order from './modules/order';

Vue.use(Vuex);

export default new Vuex.Store<RootState>({
  state,
  mutations,
  actions,
  modules: {
    user,
    cart,
    merchant,
    order,
  },
  getters: {
    filteredMerchantList: (rootState) => rootState.merchantList
      .filter((e) => {
        if (rootState.shopFilter.curbsidePickup && !e.curbsidePickup) {
          return false;
        }
        if (rootState.shopFilter.currentlyOpen && e.state !== LocationStatus.Open) {
          return false;
        }
        if (
          rootState.shopFilter.searchName
          && !e.name.toLowerCase().includes(rootState.shopFilter.searchName?.toLowerCase())
        ) {
          return false;
        }
        return true;
      }),
  },
});
